<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
      </div>
    </md-toolbar>
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div class="page-header header-filter login-background" :class="setPageClass">
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <content-footer></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import { ZoomCenterTransition } from "vue2-transitions";
  import ContentFooter from "@/pages/Layout/ContentFooter.vue";

  export default {
    components: {
      ZoomCenterTransition, ContentFooter
    },
    props: {
      backgroundColor: {
        type: String,
        default: "black"
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        responsive: false,
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 300,
        year: new Date().getFullYear(),
      };
    },
    computed: {
      setPageClass() {
        return `${this.$route.name}-page`.toLowerCase();
      }
    },
    methods: {
      toggleSidebarPage() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      toggleNavbar() {
        document.body.classList.toggle("nav-open");
        this.showMenu = !this.showMenu;
      },
      closeMenu() {
        document.body.classList.remove("nav-open");
        this.showMenu = false;
      },
      onResponsiveInverted() {
        this.responsive = window.innerWidth < 991;
      }
    },
    mounted() {
      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
      this.closeMenu();
      window.removeEventListener("resize", this.onResponsiveInverted);
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu();
        setTimeout(() => {
          next();
        }, this.menuTransitionDuration);
      } else {
        next();
      }
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.1;
  $zoomOutStart: 0.7;
  $zoomOutEnd: 0.46;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }
  .wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
  }
  @keyframes zoomOut8 {
    from {
      opacity: 1;
      transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
    }
    to {
      opacity: 0;
      transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
    }
  }
  .wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
  }
</style>
